<div class="layout-topbar">
  <div class="layout-topbar-start">
    <a class="layout-topbar-logo" routerLink="/dashboard">
      <img src="./../assets/layout/images/logo2x.png" alt="ultima-layout" style="height: 2rem">
    </a>
    <a #menuButton class="layout-menu-button" (click)="onMenuButtonClick()" pRipple>
      <i class="pi pi-chevron-right"></i>
    </a>
    <a #mobileMenuButton class="layout-topbar-mobile-button" (click)="onMobileTopbarMenuButtonClick()" pRipple>
      <i class="pi pi-ellipsis-v"></i>
    </a>
  </div>

  <div class="layout-topbar-end">
    <!--         <div class="layout-topbar-actions-start">-->
    <!--            <p-megaMenu [model]="model" styleClass="layout-megamenu"></p-megaMenu>-->
  <!--        </div>-->
  <div class="layout-topbar-actions-end">
    <ul class="layout-topbar-items">
      <!--<li class="layout-topbar-search">
      <a pStyleClass="@next" enterClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple (click)="focusSearchInput()">
        <i class="pi pi-search"></i>
      </a>

      <div class="layout-search-panel ng-hidden p-input-filled">
        <i class="pi pi-search"></i>
        <input #searchInput type="text" pInputText placeholder="Search">
        <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-text p-button-plain" pStyleClass=".layout-search-panel" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout"></button>
      </div>
    </li>-->
    <!--<li>
    <a pStyleClass="@next" enterClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple>
      <i class="pi pi-bell" pBadge severity="warning"></i>
    </a>
    <div class="ng-hidden">
      <ul class="list-none p-0 m-0">
        <li class="px-3 py-1">
          <span>You have <b>4</b> new notifications</span>
        </li>
        <li class="p-3">
          <div class="flex align-items-center">
            <img src="assets/demo/images/avatar/avatar-1.png" />
            <div class="flex flex-column ml-3 flex-1">
              <div class="flex align-items-center justify-content-between mb-1">
                <span class="font-bold">Jerome Bell</span>
                <small>42 mins ago</small>
              </div>
              <span class="text-sm line-height-3">How to write content about your photographs?</span>
            </div>
          </div>
        </li>
        <li class="p-3">
          <div class="flex align-items-center">
            <img src="assets/demo/images/avatar/avatar-2.png"/>
            <div class="flex flex-column ml-3 flex-1">
              <div class="flex align-items-center justify-content-between mb-1">
                <span class="fs-small font-bold">Cameron Williamson</span>
                <small>48 mins ago</small>
              </div>
              <span class="text-sm line-height-3">Start a blog to reach your creative peak.</span>
            </div>
          </div>
        </li>
        <li class="p-3">
          <div class="flex align-items-center">
            <img src="assets/demo/images/avatar/avatar-3.png"/>
            <div class="flex flex-column ml-3 flex-1">
              <div class="flex align-items-center justify-content-between mb-1">
                <span class="fs-small font-bold">Anna Miles</span>
                <small>1 day ago</small>
              </div>
              <span class="text-sm line-height-3">Caring is the new marketing</span>
            </div>
          </div>
        </li>
        <li class="p-3">
          <div class="flex align-items-center">
            <img src="assets/demo/images/avatar/avatar-4.png"/>
            <div class="flex flex-column ml-3 flex-1">
              <div class="flex align-items-center justify-content-between mb-1">
                <span class="fs-small font-bold">Arlene Mccoy</span>
                <small>4 day ago</small>
              </div>
              <span class="text-sm line-height-3">Starting your traveling blog with Vasco.</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </li>-->

  <!-- <li>
  <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple>
    <i class="pi pi-table"></i>
  </a>
  <div class="ng-hidden">
    <div class="flex flex-wrap">
      <div class="w-4 flex flex-column align-items-center p-3">
        <button pButton class="p-button-rounded mb-2" icon={{item.icon}} pRipple
          (click)="navigate(item.routerLink)"
        ></button>
        <span>{{item.label}}</span>
      </div>
    </div>
  </div>
</li>  -->
<li>
  <a (click)="clickNotif()" pTooltip="{{'Notify' | translate}}" tooltipPosition="left" pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="false" pRipple>
    @if (notifService.notifyCount===0) {
      <i class="pi pi-bell"></i>
    }@else {
      <i class="pi pi-bell" pBadge severity="warning"></i>
    }
  </a>
  <div id="notify" class="ng-hidden">
    <div [ngClass]="{ hidden:clickNotification===false}" class="flex flex-wrap">
      <notifications #notify pStyleClass="@grandparent" class="width-100 p-3" ></notifications>
    </div>
  </div>
</li>

@if ((isAdmin===true || menu.menuUserRole===true) && menu.menuRestrict===false) {
  <li>
    <a pTooltip="{{'Menu_AD' | translate}}" tooltipPosition="left" pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple>
      <i class="pi pi-table"></i>
    </a>
    <div class="ng-hidden">
      <div class="flex flex-wrap">
        @for (item of adminMenu; track item; let i = $index) {
          <div pStyleClass="@grandparent" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" class="w-4 flex flex-column align-items-center p-3">
            <button pButton class="p-button-rounded mb-2" icon={{item.icon}} pRipple
              (click)="navigate(item.routerLink)"
            ></button>
            <span>{{item.label}}</span>
          </div>
        }
      </div>
    </div>
  </li>
}
<!-- <li>
<a (click)="onRightMenuButtonClick()" pRipple>
  <i class="pi pi-arrow-left"></i>
</a>
</li> -->
</ul>
</div>
<span>
  {{ 'Login.Welcome' | translate }} {{ menu.userName }}
</span>
</div>
</div>
